import { createFileRoute } from '@tanstack/react-router';

import { ScorecardAdminAccessRequired } from '../../auth/scorecard-admin-access';
import ScorecardThresholdsPage from '../../views/dashboard-scorecard-thresholds';

export function ScorecardThresholdsRoute() {
  return (
    <ScorecardAdminAccessRequired>
      <ScorecardThresholdsPage />
    </ScorecardAdminAccessRequired>
  );
}

export const Route = createFileRoute('/dashboard/scorecard/thresholds')({
  component: ScorecardThresholdsRoute,
});
